export const size = {
  mobile: '500px',
  tablet: '768px',
  desktop: '1024px',
};

export const breakpoints = {
  mobile: `@media (width < ${size.mobile})`,
  tablet: `@media (width < ${size.tablet})`,
  desktopOrBigger: `@media (width >= ${size.desktop})`,
  // Separate breakpoints used for different tablet sizes
  responsiveTablet: `@media (min-width: ${size.tablet}) and (max-width: ${size.desktop})`,

  // Combined tablet and responsiveTablet
  combinedTablet: `@media (width < ${size.desktop})`,
};
